import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import AppWrapper from './AppWrapper';
//import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { AuthContextProvider } from './store/auth-context';
import store from './store';
import './i18n/config';

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <AuthContextProvider>
        <AppWrapper></AppWrapper>
      </AuthContextProvider>
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
